import { Icon, useStyleConfig } from '@chakra-ui/react';
import React from 'react';

import { WLIconProps } from '../icon.props.interface';
import * as Styles from './LinkArrow.module.scss';

const ChevronLeftIcon: React.FC<WLIconProps> = ({ variant, ...rest }) => {
  const styles = useStyleConfig('Icon', { variant });
  return (
    <Icon
      viewBox="0 0 7.113 8.395"
      width="7.113"
      height="8.395"
      {...rest}
      __css={styles}
      transform="translateX(-8px) rotate(180deg)"
      fill="inherit"
      paddingRight="16px"
    >
      <desc id="svgdescChevronLeft">chevron Left</desc>
      <path
        d="M4.152,1.357a1,1,0,0,1,1.7,0l3.2,5.113A1,1,0,0,1,8.2,8H1.8A1,1,0,0,1,.956,6.47Z"
        transform="translate(8 -0.803) rotate(90)"
      />
    </Icon>
  );
};

export default ChevronLeftIcon;
